var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamo-logo",class:{ error: _vm.displayCharNumber > 256 }},[_c('h1',[_vm._v(_vm._s(_vm.displayCharNumber))]),_c('h2',[_vm._v(_vm._s(_vm.displayCharNumber === 1 ? 'Character' : 'Characters'))])])}
var staticRenderFns = []

export { render, staticRenderFns }